import { listGuidanceTypes } from '../graphql/queries';
import { deleteGuidanceTypes } from '../graphql/mutations';

import React, { useEffect, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ManageGuidanceTypes = () => {
  const [guidanceTypes, setGuidanceTypes] = useState([]);
  const [selectedGuidances, setSelectedGuidances] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchGuidanceTypes();
  }, []);

  const fetchGuidanceTypes = async () => {
    try {
      const response = await API.graphql(graphqlOperation(listGuidanceTypes, {
        filter: {
          deleted: {
            eq: false
          }
        }
      }));

      const guidanceTypesList = response.data?.listGuidanceTypes?.items;
      setGuidanceTypes(guidanceTypesList);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectGuidance = (guidanceTypeId) => {
    if (selectedGuidances.includes(guidanceTypeId)) {
      setSelectedGuidances(selectedGuidances.filter((id) => id !== guidanceTypeId));
    } else {
      setSelectedGuidances([...selectedGuidances, guidanceTypeId]);
    }
  };

  const handleDeleteSelectedGuidances = async () => {
    try {
      for (const guidanceTypeId of selectedGuidances) {
        await API.graphql(graphqlOperation(deleteGuidanceTypes, {
          input: { id: guidanceTypeId }
        }));
      }

      setSelectedGuidances([]);
      fetchGuidanceTypes();
    } catch (error) {
      console.log("error deleting");
      console.log(error);
    }
  };

  const handleGuidanceClick = (guidanceTypeId) => {
    navigate(`/ManageGuidanceArticle/${guidanceTypeId}`);
  };


  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Checkbox
                checked={selectedGuidances.length === guidanceTypes.length}
                onChange={() => {
                  if (selectedGuidances.length === guidanceTypes.length) {
                    setSelectedGuidances([]);
                  } else {
                    setSelectedGuidances(guidanceTypes.map((guidance) => guidance.id));
                  }
                }}
              />
            </TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Short Description</TableCell>
            {/* Add more table cell headers as needed */}
          </TableRow>
        </TableHead>
        <TableBody>
          {guidanceTypes.map((guidance) => (
            <TableRow key={guidance.id}  style={{cursor: 'pointer'}}>
              <TableCell>
                <Checkbox
                  checked={selectedGuidances.includes(guidance.id)}
                  onChange={() => handleSelectGuidance(guidance.id)}
                />
              </TableCell>
              <TableCell onClick={() => handleGuidanceClick(guidance.id)}>{guidance.name}</TableCell>
              <TableCell>{guidance.description}</TableCell>
              {/* Add more table cells with guidance data as needed */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Button
        variant="contained"
        color="primary"
        onClick={handleDeleteSelectedGuidances}
        disabled={selectedGuidances.length === 0}
      >
        Delete Selected
      </Button>
    </>
  );
};

export default ManageGuidanceTypes;
